import { apiUrl } from 'config';
import axios from '../_helpers/axios';

export const reportingService = {
  getAll,
  save,
};

function getAll() {
  return axios.get(`${apiUrl}/api/reporting/`);
}

async function save(data) {
  return await axios.post(`${apiUrl}/api/reporting/saveReport`, data);
}

